import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import moment from 'moment'
import cx from 'classnames'
import {Row, Col, Button, Tooltip, OverlayTrigger} from 'react-bootstrap'
import {linkFinder} from '../../core/links'
import phonez from '../../core/phonez'
import extract, {replace, sanitize} from '../../core/extract'
import Card from '../../core/components/Card'
import Icon from '../../core/components/Icon'
import {Ticket} from '../models'
import i18n from '../i18n'
import style from './TicketAssigneeCard.less'
import Markdown from '../../core/components/Markdown'

class TicketAssigneeCard extends Component {
    static propTypes = {
        ticketIdLock: PropTypes.string,
        split: PropTypes.bool,
        onSubmit: PropTypes.func
    }

    componentWillMount() {
        const {ticket} = this.props

        const interventionScheduledJournalEvent = Ticket.findJournalEvent(ticket, 'InterventionScheduled')
        const interventionDeadlineDefinedJournalEvent = Ticket.findJournalEvent(ticket, 'InterventionDeadlineDefined')
        const formalNoticeForProviderReportedJournalEvent = Ticket.findJournalEvent(ticket, 'FormalNoticeForProviderReported')
        const interventionTimeCompliant = Ticket.isInterventionTimeCompliant(ticket)
        const repairTimeCompliant = Ticket.isRepairTimeCompliant(ticket)
        this.setState({interventionScheduledJournalEvent, interventionDeadlineDefinedJournalEvent, formalNoticeForProviderReportedJournalEvent, interventionTimeCompliant, repairTimeCompliant})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.ticket != this.props.ticket) {
            const {ticket} = nextProps

            const interventionScheduledJournalEvent = Ticket.findJournalEvent(ticket, 'InterventionScheduled')
            const interventionDeadlineDefinedJournalEvent = Ticket.findJournalEvent(ticket, 'InterventionDeadlineDefined')
            const formalNoticeForProviderReportedJournalEvent = Ticket.findJournalEvent(ticket, 'FormalNoticeForProviderReported')
            const interventionTimeCompliant = Ticket.isInterventionTimeCompliant(ticket)
            const repairTimeCompliant = Ticket.isRepairTimeCompliant(ticket)
            this.setState({interventionScheduledJournalEvent, interventionDeadlineDefinedJournalEvent, formalNoticeForProviderReportedJournalEvent, interventionTimeCompliant, repairTimeCompliant})
        }
    }

    _navigate(event, path) {
        const {dispatch} = this.props

        event.preventDefault()
        dispatch(push(path))
    }

    render() {
        const {dispatch, ticket, ticketIdLock, split, onSubmit, ...others} = this.props
        const {interventionScheduledJournalEvent, interventionDeadlineDefinedJournalEvent, formalNoticeForProviderReportedJournalEvent, interventionTimeCompliant, repairTimeCompliant} = this.state

        const cardHeader = (title) => (
            <h5>{title}</h5>
        )

        const assigneeName = (assignee) => {
            if (assignee.assigneeType == 'ProviderContact') {
                return (
                    <a
                        href=''
                        onClick={(e) => this._navigate(e, '/providercontacts/' + assignee.uid)}>
                        <h5>
                            <span>{assignee.name}</span>
                            <Icon icon='plus' size='xs' />
                        </h5>
                    </a>
                )
            } else if (assignee.assigneeType == 'ProviderCompany') {
                return (
                    <a
                        href=''
                        onClick={(e) => this._navigate(e, '/providers/' + assignee.uid)}>
                        <h5>
                            <span>{assignee.name}</span>
                            <Icon icon='plus' size='xs' />
                        </h5>
                    </a>
                )
            }

            return (
                <h5>{assignee.name}</h5>
            )
        }

        const tooltip = (text, status) => {
            return (
                <Tooltip className={status && 'tooltip-' + status}>
                    {text}
                </Tooltip>
            )
        }

        const isLocked = () => {
            if (ticketIdLock && ticketIdLock != (ticket && ticket.uid)) return true
            return !ticket
        }

        return !!(ticket && ticket.assignee) && (
            <div className={style.default}>
                <Card
                    header={cardHeader(i18n.interventionMonitoring)}
                    {...others}>
                    {!isLocked() && (
                        <Row>
                            <Col sm={split && 6 || 12}>
                                {assigneeName(ticket.assignee)}
                                <ul className={style.contact}>
                                    {ticket.assignee.phones && ticket.assignee.phones.map((phone, index) => (
                                        <li key={index}>
                                            <Icon icon='phone' size='xs' />
                                            <span> {phonez(phone).format()}</span>
                                        </li>
                                    ))}
                                </ul>
                                <ul className={style.contact}>
                                    {ticket.assignee.emails && ticket.assignee.emails.map((email, index) => (
                                        <li key={index}>
                                            <Icon icon='mail' size='xs' />
                                            <span> {email}</span>
                                        </li>
                                    ))}
                                </ul>
                                <ul className={style.contact}>
                                    {ticket.assignee.fax && ticket.assignee.fax.map((fax, index) => (
                                        <li key={index}>
                                            <Icon icon='fax' size='xs' />
                                            <span> {phonez(fax).format()}</span>
                                        </li>
                                    ))}
                                </ul>
                                {ticket.serviceOrder && (
                                    <div className={style.event}>
                                        <Icon icon='calendar' size='xs' />
                                        <div className={style.container}>
                                            <span>{replace(i18n.serviceOrder, {...ticket.serviceOrder, sendingDate: moment(ticket.serviceOrder.sendingDate).format(i18n.dateFormat.default)})}</span>
                                        </div>
                                    </div>
                                )}
                                {interventionScheduledJournalEvent && (
                                    <div className={style.event}>
                                        <Icon icon='calendar' size='xs' />
                                        <div className={style.container}>
                                            <span>{Ticket.replaceJournalEvent(Ticket.extractJournalEvent(i18n.journalEventEnum, interventionScheduledJournalEvent), interventionScheduledJournalEvent)}</span>
                                        </div>
                                    </div>
                                )}
                                {interventionDeadlineDefinedJournalEvent && (
                                    <div className={style.event}>
                                        <Icon icon='calendar' size='xs' />
                                        <div className={style.container}>
                                            <span>{Ticket.replaceJournalEvent(Ticket.extractJournalEvent(i18n.journalEventEnum, interventionDeadlineDefinedJournalEvent), interventionDeadlineDefinedJournalEvent)}</span>
                                        </div>
                                    </div>
                                )}
                                {formalNoticeForProviderReportedJournalEvent && (
                                    <div className={style.event}>
                                        <Icon icon='calendar' size='xs' />
                                        <div className={style.container}>
                                            <span>{Ticket.replaceJournalEvent(Ticket.extractJournalEvent(i18n.journalEventEnum, formalNoticeForProviderReportedJournalEvent), formalNoticeForProviderReportedJournalEvent)}</span>
                                        </div>
                                    </div>
                                )}
                                {ticket.assignee.comment && (
                                    <div className={cx(style.comment, style.warning)}>
                                        <p><Markdown markdown={ticket.assignee.comment}/></p>
                                    </div>
                                )}
                                {ticket.assignee.instructionsForAssignee && (
                                    <div className={cx(style.comment, style.warning)}>
                                        <p><strong>instructions: </strong><Markdown markdown={ticket.assignee.instructionsForAssignee}/></p>
                                    </div>
                                )}
                                {onSubmit && (
                                    <ul className={style.callingGroup}>
                                        <li>
                                            {ticket._links.find(linkFinder('EmitCallTo')) && (
                                                <Button
                                                    onClick={(e) => onSubmit(e, 'EmitCallTo', ticket.assignee)}>
                                                    <p>{i18n.emitCallz}</p>
                                                    <Icon icon='emitCall' size='sm' />
                                                </Button>
                                            )}
                                        </li>
                                        <li>
                                            {ticket._links.find(linkFinder('ReceiveCall')) && (
                                                <Button
                                                    onClick={(e) => onSubmit(e, 'ReceiveCall', ticket.assignee)}>
                                                    <p>{i18n.receiveCallz}</p>
                                                    <Icon icon='receiveCall' size='sm' />
                                                </Button>
                                            )}
                                        </li>
                                    </ul>
                                )}
                            </Col>
                            <Col sm={split && 6 || 12}>
                                <div className={style.metricGroup}>
                                    <div className={cx(style.metric, {[style.danger]: !interventionTimeCompliant})}>
                                        <p>{i18n.interventionTime}</p>
                                        <OverlayTrigger
                                            placement='bottom'
                                            overlay={tooltip(replace(i18n.interventionTimeText, {token: !interventionTimeCompliant}), interventionTimeCompliant && 'primary' || 'danger')}>
                                            <div className={style.time}>
                                                {ticket.stats.interventionTime && moment.duration(ticket.stats.interventionTime).humanize() || '---'}
                                            </div>
                                        </OverlayTrigger>
                                    </div>
                                    <div className={style.metric}>
                                        <p>{i18n.interventionDuration}</p>
                                        <OverlayTrigger
                                            placement='bottom'
                                            overlay={tooltip(i18n.interventionDurationText, 'primary')}>
                                            <div className={style.time}>
                                                {ticket.stats.interventionDuration && moment.duration(ticket.stats.interventionDuration).humanize() || '---'}
                                            </div>
                                        </OverlayTrigger>
                                    </div>
                                    <div className={cx(style.metric, {[style.danger]: !repairTimeCompliant})}>
                                        <p>{i18n.repairTime}</p>
                                        <OverlayTrigger
                                            placement='bottom'
                                            overlay={tooltip(replace(i18n.repairTimeText, {token: !repairTimeCompliant}), repairTimeCompliant && 'primary' || 'danger')}>
                                            <div className={style.time}>
                                                {ticket.stats.repairTime && moment.duration(ticket.stats.repairTime).humanize() || '---'}
                                            </div>
                                        </OverlayTrigger>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col></Col>
                        <Col></Col>
                    </Row>
                    {isLocked() && (
                        <div className={style.noTicketInfo}>
                            <span>{i18n.noTicketInfo}</span>
                        </div>
                    )}
                </Card>
            </div>
        )
    }
}

TicketAssigneeCard = connect((state) => ({
    ticket: state.ticket.ticket
}))(TicketAssigneeCard)

export default TicketAssigneeCard


// WEBPACK FOOTER //
// ./lib/ticket/components/TicketAssigneeCard.js